export const routes = [
  {
    path: 'ixc/comunicados',
    name: 'ixc_announcements',
    component: () => import('./Announcements.vue'),
    meta: { permissions: ['administrator'] },
  },
];
